import React from 'react';
import HolidayHero from '../Components/HolidayHero/HolidayHero';
import TourPackages from '../Components/TourPackages/TourPackages';
// import DomesticPackages from '../Components/DomesticPackages/DomesticPackages';
// import SpecialPackages from '../Components/SpecialPackages/SpecialPackages';
 import InternationalTours from '../Components/InternationalTours/InternationalTours';
import CustomizedTours from '../Components/CustomizedTours/CustomizedTours';
// import AdventurePackages from '../Components/AdventurePackages/AdventurePackages';






const Holiday = () => {
  return (
    <>
     
    <HolidayHero /> 
    <TourPackages />
    {/* <DomesticPackages /> */}
    {/* <SpecialPackages /> */}
    { <InternationalTours /> }
    <CustomizedTours />
    {/* <AdventurePackages /> */}
        
    </>
  );
};

export default Holiday;
